import { render, staticRenderFns } from "./AddDept.vue?vue&type=template&id=f6e82608&scoped=true"
import script from "./AddDept.vue?vue&type=script&lang=js"
export * from "./AddDept.vue?vue&type=script&lang=js"
import style0 from "./AddDept.vue?vue&type=style&index=0&id=f6e82608&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e82608",
  null
  
)

export default component.exports